const votings_data = [
  {
    id: '1934534',
    status: 'upcoming',
    subject: 'social transport',
    title: 'Set a dedline for the capitol to install ticket check/pass gates',
    initiated_by: 'Momentum (political party)',
    level: 'country',
    location: 'Hungary',
    start_date: new Date('2023.08.15'),
    end_date: new Date('2023.08.31'),
  },
  {
    id: '1934532',
    status: 'upcoming',
    subject: 'sport',
    title: 'Let Hungary to be the organiser of the Athelic VB',
    initiated_by: 'Hungarian government',
    level: 'country',
    location: 'Hungary',
    start_date: new Date('2023.09.12'),
    end_date: new Date('2023.10.12'),
  },
  {
    id: '1934531',
    status: 'active',
    subject: 'education',
    title: '10% wage raise for the teachers',
    initiated_by: 'DK (political party)',
    level: 'country',
    location: 'Hungary',
    start_date: new Date('2023.07.12'),
    end_date: new Date('2023.07.31'),
  },
  {
    id: '1934530',
    status: 'active',
    subject: 'data',
    title: 'Enable the access to the post communist era classified agent files',
    initiated_by: 'Jobbik (political party)',
    level: 'country',
    location: 'Hungary',
    start_date: new Date('2023.07.09'),
    end_date: new Date('2023.08.09'),
  },
  {
    id: '1934529',
    status: 'active',
    subject: 'taxes',
    title: 'Apply extra 5% tax on citizens whoes monthly income is above 5 million HUF',
    initiated_by: 'Mayor office',
    level: 'city',
    location: 'Budapest',
    start_date: new Date('2023.06.01'),
    end_date: new Date('2023.07.15'),
  },
  {
    id: '1934528',
    status: 'active',
    subject: 'sports',
    title: 'Build an atletic stadium',
    initiated_by: 'Mayor office',
    level: 'city',
    location: 'Debrecen',
    start_date: new Date('2023.06.01'),
    end_date: new Date('2023.07.15'),
  },
  {
    id: '1934527',
    status: 'closed',
    subject: 'education',
    title: 'Provide 50 billion HUF education package for kids living in poverty',
    initiated_by: 'LMP (political party)',
    level: 'county',
    location: 'Hungary',
    start_date: new Date('2023.06.01'),
    end_date: new Date('2023.06.14'),
  },
  {
    id: '1934526',
    status: 'closed',
    subject: 'corruption',
    title: 'Family members of politicans fall into the same category of monitor wealth increase and connections',
    initiated_by: 'LMP (political party)',
    level: 'county',
    location: 'Hungary',
    start_date: new Date('2023.06.01'),
    end_date: new Date('2023.06.14'),
  },
];

export default votings_data;
